import request from 'superagent'

export function camelize(text) {
  const a = text.toLowerCase()
      .replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');
  return a.substring(0, 1).toLowerCase() + a.substring(1);
}

export function formatFloat(number, currency = false, decimals = 2) {
  const formatted = parseFloat(number).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  })
  if (currency) {
    return formatted.replace(/,/g, ' ').replace('.', ',') + ' €'
  } else {
    return formatted.replace(/,/g, ' ').replace('.', ',')
  }
}

export function cleanFloat(number) {
  return (parseFloat(number.toString().replace(',', '.').replace('€', '').replace(' ', '').trim()) || 0)
}


function readAppContext() {
  const meta = document.querySelector('meta[name="app-context"]');
  if (!meta) return { user: null };
  try { return JSON.parse(meta.content); } catch { return { user: null }; }
}

const APP = readAppContext();

export const currentUser = () => APP.user;
export const currentUserRole = () => (APP.user ? APP.user.role : null);
export const isRole = (role) => currentUserRole() === role;

